import { render, staticRenderFns } from "./AgentAssistantMessage.vue?vue&type=template&id=698546b7&scoped=true&"
import script from "./AgentAssistantMessage.vue?vue&type=script&lang=js&"
export * from "./AgentAssistantMessage.vue?vue&type=script&lang=js&"
import style0 from "./AgentAssistantMessage.vue?vue&type=style&index=0&id=698546b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698546b7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
